// extracted by mini-css-extract-plugin
export default {"root":"IconButton_root__Hxi9Q","lg":"IconButton_lg__rhQOH","md":"IconButton_md__zU01Q","sm":"IconButton_sm__pz7qB"};